type HttpErrorLike = {
  response?: {
    status?: number;
  };
};

export function getSupportBuilderLaunchError(error: unknown): string {
  const status = typeof error === "object" && error !== null
    ? (error as HttpErrorLike).response?.status
    : undefined;

  if (status === 401) {
    return "La sesión fue revocada, venció o el enlace ya fue usado. Crea una sesión nueva desde el backoffice.";
  }
  if (status === 403) {
    return "La sesión está activa, pero no tiene permiso para abrir el editor. Contacta al equipo técnico.";
  }
  if (status === 404) {
    return "El acceso seguro al editor no está disponible en este entorno.";
  }
  if (status !== undefined && status >= 500) {
    return "El servicio no pudo preparar el acceso al editor. Intenta de nuevo en unos minutos.";
  }
  if (status === undefined) {
    return "No pudimos conectarnos al servicio que abre el editor. Revisa tu conexión e intenta de nuevo.";
  }
  return "No se pudo preparar el acceso al editor. Crea una sesión nueva desde el backoffice.";
}
